export const roles = {
  admin: 'Admin',
  clinic: 'IAdmin',
  amp: 'Amp',
};
